import NavMenuItem from "../ui/nav-menu-item";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import SideBarContext from "../../contexts/side-bar-context";
import { useContext } from "react";
import DynamicIcon from "../ui/dynamic-icon";
import ComingSoonText from "../ui/coming-soon-text";
import { isPegInstalled } from "../../lib/auth";

const BottomMenuItems = () => {
  const userCtx = useContext(UserContext);
  const { activeBusiness, isDeveloperRegistered } = useContext(BusinessContext);
  const business = activeBusiness;
  const user = userCtx.user;
  const { isSettingsOpen, toggleSettings } = useContext(SideBarContext);

  if (isDeveloperRegistered === false) return null;
  
  return (
    <div className="grid gap-[4px] mb-[20px]">
      {(user.is_pseudonymous === false && business.is_pseudonymous === false ) &&
        <NavMenuItem icon='settings' href='/manage-people'>Settings</NavMenuItem>
      }
      <NavMenuItem normalizeRoute={true} newTab tooltipTitle='Report a bug' tooltipBody='Click here to notify us of any issues or glitches in the system. Your feedback helps us improve!' tooltipCount={1} icon='bug' href="https://forms.gle/rqLWcSkrpiNouynD8">Report a Bug</NavMenuItem>
      <NavMenuItem normalizeRoute={true} newTab icon='life-buoy' href="https://docs.google.com/forms/d/e/1FAIpQLScIaAP1FSbZuFGwPsxp4ojs8IkK0IT29JsAdOtrKAlpiaMQhg/viewform">Help & Support</NavMenuItem>
    </div>
  );
};

export default BottomMenuItems;
